import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    height: 100vh;
    max-width: 1500px;
    flex: 1;
    flex-wrap: nowrap;
    overflow: hidden;
    margin-right: auto;
    margin-left: auto;
    nav {
        height: auto;
        align-self: normal;
        flex-shrink: 0;
    }
    
    aside {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        > main{
            overflow: auto;
            flex: 1;
            height: 100%;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        overflow: auto!important;
        
        aside{
            height: fit-content;
        }
        aside main {
            margin: 2rem 0 5rem;
        }
    }
`